export const GET_SCHEDULED_STREAMS = 'GET_SCHEDULED_STREAMS';
export const GET_SCHEDULED_STREAMS_SUCCESS = 'GET_SCHEDULED_STREAMS_SUCCESS';
export const GET_SCHEDULED_STREAMS_ERROR = 'GET_SCHEDULED_STREAMS_ERROR';

// Fetch single stream
export const GET_SCHEDULED_STREAM = 'GET_SCHEDULED_STREAM';
export const GET_SCHEDULED_STREAM_SUCCESS = 'GET_SCHEDULED_STREAM_SUCCESS';
export const GET_SCHEDULED_STREAM_ERROR = 'GET_SCHEDULED_STREAM_ERROR';

// Create new stream
export const CREATE_SCHEDULED_STREAM = 'CREATE_SCHEDULED_STREAM';
export const CREATE_SCHEDULED_STREAM_SUCCESS =
  'CREATE_SCHEDULED_STREAM_SUCCESS';
export const CREATE_SCHEDULED_STREAM_ERROR = 'CREATE_SCHEDULED_STREAM_ERROR';

// Update stream
export const UPDATE_SCHEDULED_STREAM = 'UPDATE_SCHEDULED_STREAM';
export const UPDATE_SCHEDULED_STREAM_SUCCESS =
  'UPDATE_SCHEDULED_STREAM_SUCCESS';
export const UPDATE_SCHEDULED_STREAM_ERROR = 'UPDATE_SCHEDULED_STREAM_ERROR';

// Delete stream
export const DELETE_SCHEDULED_STREAM = 'DELETE_SCHEDULED_STREAM';
export const DELETE_SCHEDULED_STREAM_SUCCESS =
  'DELETE_SCHEDULED_STREAM_SUCCESS';

export const SIGN_UP_FOR_STREAM = 'SIGN_UP_FOR_STREAM';
export const SIGN_UP_FOR_STREAM_SUCCESS = 'SIGN_UP_FOR_STREAM_SUCCESS';
export const SIGN_UP_FOR_STREAM_ERROR = 'SIGN_UP_FOR_STREAM_ERROR';
